import { all, call, fork, put, select, takeEvery } from 'bukku/shared/SagaService';
import {message} from 'antd';
import actions from './actions';
import AppActions from '../App/actions';
import AuthActions from '../Auth/actions';
import {deleto, get, post, puto} from 'bukku/shared/ApiService';
import {t} from "@lingui/macro";

export function getApiUrl(clientId) {
    return clientId ? `/partners/current/clients/${clientId}/accesses` : '/accesses';
}

export function getAppUrl(clientId) {
    return clientId ? `/partners/clients/${clientId}/users` : '/cp/users';
}

// Create access
export function* createAccessRequest() {
    yield takeEvery(actions.CREATE_ACCESS_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });

            const { Access } = yield select();
            const response = yield call(post, getApiUrl(Access.clientId), request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.CREATE_ACCESS_SUCCESS,
                access: data.access,
            });
        }
        catch (error) {
            yield put({
                type: actions.CREATE_ACCESS_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* createAccessSuccess() {
    yield takeEvery(actions.CREATE_ACCESS_SUCCESS, function* () {
        yield message.success(t`The user invite is sent.`);
    });
}
export function* createAccessError() {
    yield takeEvery(actions.CREATE_ACCESS_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Read accesses
export function* readAccessesRequest() {
    yield takeEvery(actions.READ_ACCESSES_REQUEST, function* ({ request, clientId }, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });

            const { Access } = yield select();
            const response = yield call(get, getApiUrl(clientId || Access.clientId), request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.READ_ACCESSES_SUCCESS,
                accesses: data.accesses,
                accessesPagination: data.paging,
            });
        }
        catch (error) {
            yield put({
                type: actions.READ_ACCESSES_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readAccessesSuccess() {
    yield takeEvery(actions.READ_ACCESSES_SUCCESS, () => {});
}
export function* readAccessesError() {
    yield takeEvery(actions.READ_ACCESSES_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Read access
export function* readAccessRequest() {
    yield takeEvery(actions.READ_ACCESS_REQUEST, function* ({ id }, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });

            const { Access } = yield select();
            const response = yield call(get, `${getApiUrl(Access.clientId)}/${id}`, null, context);
            const data = yield response.data;

            yield put({
                type: actions.READ_ACCESS_SUCCESS,
                access: data.access,
            });
        }
        catch (error) {
            yield put({
                type: actions.READ_ACCESS_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readAccessSuccess() {
    yield takeEvery(actions.READ_ACCESS_SUCCESS, () => {});
}
export function* readAccessError() {
    yield takeEvery(actions.READ_ACCESS_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Update access
export function* updateAccessRequest() {
    yield takeEvery(actions.UPDATE_ACCESS_REQUEST, function* ({ id, request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });

            const { Access } = yield select();
            const response = yield call(puto, `${getApiUrl(Access.clientId)}/${id}`, request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.UPDATE_ACCESS_SUCCESS,
                access: data.access,
            });
        }
        catch (error) {
            yield put({
                type: actions.UPDATE_ACCESS_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* updateAccessSuccess() {
    yield takeEvery(actions.UPDATE_ACCESS_SUCCESS, function* () {
        yield message.success(t`User access is updated.`);
    });
}
export function* updateAccessError() {
    yield takeEvery(actions.UPDATE_ACCESS_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Resend invite access
export function* inviteAccessRequest() {
    yield takeEvery(actions.INVITE_ACCESS_REQUEST, function* ({ id }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });

            const { Access } = yield select();
            yield call(post, `${getApiUrl(Access.clientId)}/${id}/invite`, null, context);
            yield put({
                type: actions.INVITE_ACCESS_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.INVITE_ACCESS_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* inviteAccessSuccess() {
    yield takeEvery(actions.INVITE_ACCESS_SUCCESS, function* () {
        yield message.success(t`User invite resent.`);
    });
}
export function* inviteAccessError() {
    yield takeEvery(actions.INVITE_ACCESS_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Delete access
export function* deleteAccessRequest() {
    yield takeEvery(actions.DELETE_ACCESS_REQUEST, function* ({ id }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });

            const { Access } = yield select();
            yield call(deleto, `${getApiUrl(Access.clientId)}/${id}`, null, context);
            yield put({
                type: actions.DELETE_ACCESS_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.DELETE_ACCESS_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* deleteAccessSuccess() {
    yield takeEvery(actions.DELETE_ACCESS_SUCCESS, function* () {
        yield message.success(t`User access is removed.`);
    });
}
export function* deleteAccessError() {
    yield takeEvery(actions.DELETE_ACCESS_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Delete access
export function* makeOwnerRequest() {
    yield takeEvery(actions.MAKE_OWNER_REQUEST, function* ({ id, password }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });

            context.allow_intercept = true;
            yield call(puto, `/accesses/${id}/make_owner`, {password}, context);
            yield put({
                type: actions.MAKE_OWNER_SUCCESS,
            });
            yield put({
                type: AuthActions.VALIDATE_SESSION_REQUEST,
            });
        }
        catch (error) {
            yield put({
                type: actions.MAKE_OWNER_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* makeOwnerSuccess() {
    yield takeEvery(actions.MAKE_OWNER_SUCCESS, function* () {
        yield message.success(t`Transfer of ownership is successful.`);
    });
}
export function* makeOwnerError() {
    yield takeEvery(actions.MAKE_OWNER_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Grant/Disable Partner Access
export function* updatePartnerAccessRequest() {
    yield takeEvery(actions.UPDATE_USER_PARTNER_ACCESS_REQUEST, function* ({request}) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });

            const response = yield call(puto, `/accesses/partner_manage_users`, request);
            const data = yield response.data;
            yield put({
                type: actions.UPDATE_USER_PARTNER_ACCESS_SUCCESS,
                partner_manage_users: data.partner_manage_users,
            });
        }
        catch (error) {
            yield put({
                type: actions.UPDATE_USER_PARTNER_ACCESS_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_START_PUSHING });
        }
    });
}
export function* updatePartnerAccessSuccess() {
    yield takeEvery(actions.UPDATE_USER_PARTNER_ACCESS_SUCCESS, function* () {
        yield message.success(t`Partner access successfully updated.`);
    });
}
export function* updatePartnerAccessError() {
    yield takeEvery(actions.UPDATE_USER_PARTNER_ACCESS_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

export default function* rootSaga() {
    yield all([
        fork(createAccessRequest),
        fork(createAccessSuccess),
        fork(createAccessError),
        fork(readAccessesRequest),
        fork(readAccessesSuccess),
        fork(readAccessesError),
        fork(readAccessRequest),
        fork(readAccessSuccess),
        fork(readAccessError),
        fork(updateAccessRequest),
        fork(updateAccessSuccess),
        fork(updateAccessError),
        fork(inviteAccessRequest),
        fork(inviteAccessSuccess),
        fork(inviteAccessError),
        fork(deleteAccessRequest),
        fork(deleteAccessSuccess),
        fork(deleteAccessError),
        fork(makeOwnerRequest),
        fork(makeOwnerSuccess),
        fork(makeOwnerError),
        fork(updatePartnerAccessRequest),
        fork(updatePartnerAccessSuccess),
        fork(updatePartnerAccessError),
    ]);
}
